import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import SuccessIcon from '../../Assets/Images/DashboardMigrants/check.svg'
import ErrorIcon from '../../Assets/Images/DashboardMigrants/chatbot.png'
export const toastSweetAlert = async ({
  message,
  mode,
  icon = false,
  title,
  titleMessage = null,
  text = null,
  denyButtonText = 'Cancelar',
  denyButtonClass = 'btn btn-migrates-white',
  htmlContainerClass = 'StandarModalHtmlContainer',
  popupClass = '',
  confirmButtonText = 'Ok',
  content = {},
  validator = () => {},
  showConfirmButton = true,
  showDenyButton = true,
  showCancelButton = true,
  showCloseButton = true,

  timerToast = 3000,
}) => {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: timerToast,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    },
  })

  const MySwal = withReactContent(Swal)

  switch (mode) {
    case 'okToast':
      return Toast.fire({
        icon: 'success',
        title: `${message}`,
        text,
      })
    case 'errorToast':
      return Toast.fire({
        icon: 'error',
        title: `${message}`,
        text,
      })
    case 'warningToast':
      return Toast.fire({
        icon: 'warning',
        title: `${message}`,
        text,
      })
    case 'infoToast':
      return Toast.fire({
        icon: 'info',
        title: `${message}`,
        text,
      })

    case 'ok':
      // return Toast.fire({
      //   icon: 'success',
      //   title: `${message}`,
      // })

      return MySwal.fire({
        showCloseButton: true,
        title,
        // icon: 'error',
        html: (
          <>
            <div className="errorModal">
              <img src={SuccessIcon} alt="success-icon" />
              {titleMessage ? (
                <div className="title-container">
                  <h5 className="title-migrates">{titleMessage}</h5>
                </div>
              ): (<div className='mb-4'></div> )}
              <div className="message-container">
                {message ? message : 'Exito.'}
              </div>
            </div>
          </>
        ),
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: true,
        confirmButtonText: 'CERRAR',
        focusConfirm: false,
        customClass: {
          title: 'StandarModalTitle',
          htmlContainer: htmlContainerClass,
          confirmButton: 'btn btn-migrates-white',
        },
      })

    case 'loading':
      return MySwal.fire({
        showCloseButton: false,
        title: title,
        icon: icon || undefined,
        html: (
          <>
            <div className="errorModal">
              <div className="message-container">
                {message ? message : 'Loading, please wait...'}
              </div>
            </div>
          </>
        ),
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: false,
        customClass: {
          title: 'StandarModalTitle',
          htmlContainer: htmlContainerClass,
          confirmButton: 'btn btn-migrates',
        },
        didOpen: () => {
          Swal.showLoading()
        },
      })

    case 'error':
      return MySwal.fire({
        showCloseButton: true,
        title: 'Error',
        icon: 'error',
        html: (
          <>
            <div className="errorModal">
              {/* <img src={ErrorIcon} alt="error-icon" /> */}
              {titleMessage ? (
                <div className="title-container">
                  <h5 className="title-migrates">{titleMessage}</h5>
                </div>
              ):(<div className='mb-4'></div>)}
              <div className="message-container">
                {message ? message : 'Algo salió mal, vuelve a intentar.'}
              </div>
            </div>
          </>
        ),
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: true,
        focusConfirm: false,
        confirmButtonText: 'Ok',
        customClass: {
          title: 'StandarModalTitle',
          htmlContainer: htmlContainerClass,
          confirmButton: 'btn btn-migrates',
        },
      })

    case 'okModal':
      Swal.fire({
        title: 'Bien',
        text: message,
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-sm btn-migrates',
        },
        buttonsStyling: false,
        allowOutsideClick: false,
        focusConfirm: false,
      })
      break

    case 'errorModal':
      Swal.fire({
        title: 'Error',
        text: message,
        icon: 'error',
        allowOutsideClick: false,
        focusConfirm: false,
        confirmButtonText: '<i class="fas fa-check"> Ok</i>',
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-sm btn-migrates',
        },
      })
      break

    case 'finishOrder':
      return MySwal.fire({
        showCloseButton: true,
        title: 'Pedido agregado',
        html: (
          <>
            <div className="errorModal">
              <div className="message-container">
                {message ? message : 'Exito.'}
              </div>
            </div>
          </>
        ),
        allowOutsideClick: false,
        buttonsStyling: false,
        confirmButtonText: 'Ver orden',
        cancelButtonText: 'Finalizar',
        showConfirmButton: true,
        showCancelButton: true,
        reverseButtons: true,
        focusConfirm: false,
        customClass: {
          title: 'StandarModalTitle',
          htmlContainer: htmlContainerClass,
          confirmButton: 'btn btn-migrates',
          cancelButton: denyButtonClass,
        },
      }).then((result) => {
        if (result.isConfirmed) {
          console.log('ver orden')
          window.location.replace('/telemarketingOrderHistory/details/2/status')
        } else {
          window.location.replace('/telemarketingOrderHistory')
        }
      })

    case 'modalConfirmCancel':
      return MySwal.fire({
        showCloseButton: true,
        icon: icon,
        title: title,
        html: (
          <>
            <div className="message-container">{message}</div>
          </>
        ),
        allowOutsideClick: false,
        buttonsStyling: false,
        showDenyButton: true,
        confirmButtonText: confirmButtonText,
        denyButtonText: denyButtonText,
        reverseButtons: true,
        customClass: {
          title: 'StandarModalTitle',
          htmlContainer: htmlContainerClass,
          confirmButton: 'btn btn-migrates',
          denyButton: denyButtonClass,
          footer: 'btn StandarModalFooterLogOut',
        },
      }).then(async (result) => {
        return result
      })

    case 'modalConfirmContent':
      return MySwal.fire({
        showCloseButton: true,
        icon: icon,
        title: title,
        html: content,
        focusConfirm: false,
        allowOutsideClick: false,
        buttonsStyling: false,
        showDenyButton: true,
        confirmButtonText: confirmButtonText,
        denyButtonText: denyButtonText,
        reverseButtons: true,
        customClass: {
          title: 'StandarModalTitle',
          htmlContainer: htmlContainerClass,
          confirmButton: 'btn btn-migrates',
          denyButton: denyButtonClass,
          footer: 'btn StandarModalFooterLogOut',
          popup: popupClass, // Added class for taller modal
        },
        preConfirm: validator,
      }).then(async (result) => {
        return result
      })

    case 'modalGeneric':
      MySwal.fire({
        icon: icon,
        title,
        html: (
          <>
            <div className="errorModal">
              <div className="message-container">
                {message ? message : 'Exito.'}
              </div>
            </div>
          </>
        ),
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: showConfirmButton,
        showCloseButton: showCloseButton,
        confirmButtonText: 'Ok',
        focusConfirm: false,
        customClass: {
          title: 'StandarModalTitle',
          htmlContainer: htmlContainerClass,
          confirmButton: 'btn btn-migrates',
        },
      })
      break

    default:
    case 'messageModal':
      Swal.fire({
        text: message,
        customClass: {
          confirmButton: 'btn btn-sm btn-migrates',
        },
      })
      break
  }
}
